import React from 'react'
import reduxConnection from '../Store'
import WOW from 'wow.js'
import ScrollableAnchor from 'react-scrollable-anchor'
import { configureAnchors } from 'react-scrollable-anchor'

//////////////// IMPORT COMPONENTS /////////////////

import Header from './header'
import Navigation from './navigation'
import Apps from './apps'
import MotionGraphics from './motionGraphics'
import DigitalArt from './digitalArt'
import Music from './music'
import ThisWebsite from './thisWebsite'

import AboutMe from './aboutMe'
import MoreAboutMe from './aboutMe_more'
import Footer from './footer'

////////////// INTERNAL DEPENDENCIES //////////////

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/HomePage.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')
// require('../js_animations/navScroll.js')

//////////////////// VARIABLES ////////////////////

let myEmail = "SONICCCLOUDS@GMAIL.COM",
    myPhone = "571-235-6005",
    logo_white_PNG = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Logos/Logo_1_white.png",
    logo_blue_PNG_960 = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Logos/Logo_1__blue_960.png",
    logo_blue_PNG_100 = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Logos/Logo_1__blue_100.png",
    logo_blue_PNG_70 = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Logos/Logo_1__blue_70.png",
    logo_blue_PNG_16 = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/Logos/Logo_1__blue_16.png",

    mouse_graphic_icon = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/arrow__down_1__edit_1.png",

    backToTop_icon = "https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/arrow__up_1__edit_1.png"

let wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    // offset: 200,
    mobile: true,
    live: true
  })

wow.init()


// configureAnchors({scrollDuration: 4000})


//////////////////// CREATE COMPONENTS ////////////////////////////////////////////////////////////


class Home extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.state = {
      play1: false,
      play2: false,
      play3: false,
      clickCount1: 0,
      clickCount2: 0,
      clickCount3: 0,

      descriptionClassToggle_A: 'wow fadeInUp hover-fade-in',
      descriptionClassToggle_B: 'hover-fade-out',

      contactMeToggle: "contact me",
      contactMeToggle_2: "ask me a question",

      copied: true,
      copiedMessageClass_1: 'copiedMessage copyFadeOut',
      copiedMessageClass_2: 'copiedMessage copyFadeOut',
      copiedMessageClass_3: 'copiedMessage copyFadeOut',

      portrait_1: "portrait ",
      portrait_2: "portrait display_portrait_OFF",
    }

  }

  // FUNCTIONS ===================================================



  logoLinkClicked = () => {
    let element = this.refs.AboutMe
    element.scrollIntoView()
  }


  appsLinkClicked = () => {

    console.log("inside appsLinkClicked");

    // let element = this.refs.Apps
    // element.scrollIntoView();
    // element.scrollTop = 0

    // manually reset the other links

    // responsive 1 // min-width: 1178px

    // reset motion graphics
    this.resetMotionGraphics()
  }

  motionGraphicsLinkClicked = () => {

    console.log("inside motionGraphicsLinkClicked");

    let element = this.refs.MotionGraphics
    element.scrollIntoView();
  }

  digitalArtLinkClicked = () => {

    console.log("inside digitalArtLinkClicked");

    let element = this.refs.DigitalArt
    element.scrollIntoView();
  }

  musicLinkClicked = () => {

    console.log("inside musicLinkClicked");

    let element = this.refs.Music
    element.scrollIntoView();

  }

  // reset nav links

  // responsive 1 // min-width: 1178px

  // reset motion graphics
  resetMotionGraphics = () => {
    var link = document.getElementById('menu_link_MotionGraphics_r1')



      link.style.left = '73vw'
      link.style.fontSize = '.8rem'
      link.style.top = '2vh'
      link.style.width = '150px'

      console.log("checking link.style.left", link.style.left)
      console.log("checking link.style.fontSize", link.style.fontSize)
      console.log("checking link.style.top", link.style.top)
      console.log("checking link.style.width", link.style.width)

  }


  togglePlay = (video) => {
    if (video === 'play1') {
      this.setState({
        play1: !this.state.play1
      })
    } else if (video === 'play2') {
      this.setState({
        play2: !this.state.play2
      })
    } else if (video === 'play3') {
      this.setState({
        play3: !this.state.play3
      })
    }
  }

  // NOTE: find a way to identify video based on event, then refactor these 3 functions to a single function 'toggleVideo()'
  toggleVideo_1 = (event) => {

    console.log('inside toggleVideo_1')
    console.log("checking state:", this.state)
    console.log("checking event:", event)

    let video = document.getElementById('video_1')

    if (this.state.clickCount1 === 0) {
      video.pause()
      this.setState({
        clickCount1: 1
      })
    } else {
      this.togglePlay('play1')
      if (!(video.paused) && !(video.ended) && video.currentTime > 0) {
        video.pause()
      } else {
        video.play()
      }
    }
  }
  toggleVideo_2 = (event) => {
    let video = document.getElementById('video_2')
    if (this.state.clickCount2 === 0) {
      video.pause()
      this.setState({
        clickCount2: 1
      })
    } else {
      this.togglePlay('play2')
      if (!(video.paused) && !(video.ended) && video.currentTime > 0) {
        video.pause()
      } else {
        video.play()
      }
    }
  }
  toggleVideo_3 = (event) => {
    let video = document.getElementById('video_3')
    if (this.state.clickCount3 === 0) {
      video.pause()
      this.setState({
        clickCount3: 1
      })
    } else {
      this.togglePlay('play3')
      if (!(video.paused) && !(video.ended) && video.currentTime > 0) {
        video.pause()
      } else {
        video.play()
      }
    }

  }

  // NOTE: NOT CURRENTLY IN USE -- keeping for reference and/or future use
  // hoverOverlay_ON = (e) => {
  //   let target = e.target
  //   target.style.opacity = .9
  //   this.setState({
  //     descriptionClassToggle_A: "hover-fade-out",
  //     descriptionClassToggle_B: "wow fadeIn hover-fade-in"
  //   })
  // }
  // hoverOverlay_OFF = (e) => {
  //   let target = e.target
  //   target.style.opacity = 0
  //   this.setState({
  //     descriptionClassToggle_A: "wow fadeIn hover-fade-in",
  //     descriptionClassToggle_B: "hover-fade-out"
  //   })
  // }

  contactButtonHover_ON_thisWebsite = (e) => {
    this.setState({
      contactMeToggle: "click to copy email"
    })
  }
  contactButtonHover_OFF_thisWebsite = (e) => {
    this.setState({
      contactMeToggle: "contact me"
    })
  }
  // CLICK TO COPY
  contactButtonClicked_thisWebsite = (e) => {
    this.setState({
      copiedMessageClass_1: 'copiedMessage copyFadeIn_1',
    })
  }

  contactButtonHover_ON_skills = (e) => {
    this.setState({
      contactMeToggle_2: "click to copy email"
    })
  }
  contactButtonHover_OFF_skills = (e) => {
    this.setState({
      contactMeToggle_2: "ask me a question"
    })
  }
  // CLICK TO COPY
  contactButtonClicked_skills = (e) => {
    this.setState({
      copiedMessageClass_2: 'copiedMessage copyFadeIn_2',
    })
  }
  contactButtonClicked_aboutMe = (e) => {
    this.setState({
      copiedMessageClass_3: 'copiedMessage copyFadeIn_3',
    })
  }

  onCopy = () => {
    this.setState({copied: true})
  }

  // NOTE: needs debugging // very glitchy // temporarily deactivated
  // togglePortrait_ON = () => {
  //   this.setState({
  //     portrait_1: "portrait display_portrait_OFF",
  //     portrait_2: "portrait"
  //   })
  // }
  // togglePortrait_OFF = () => {
  //   this.setState({
  //     portrait_1: "portrait",
  //     portrait_2: "portrait display_portrait_OFF"
  //   })
  // }



  // closes functions ==========================================


  render(){

    console.log("checking reduxConnection...", reduxConnection)
    console.log("checking this.props:", this.props)
    console.log("checking window:", window)

    return (

      <div className="enclosure" >

        <div className="secondary-enclosure">



{/* SECTION 1: HEADER ******************************/}

{          //
          // <a href="#Apps_component" id="testLink">TEST_LINK</a>
          //
}
          <ScrollableAnchor id={"_top"}>
            <div></div>
          </ScrollableAnchor>

          <Header
            id="Header_component"
            myEmail = {myEmail}
            myPhone = {myPhone}
            logo_white_PNG = {logo_white_PNG}
            logo_blue_PNG_960 = {logo_blue_PNG_960}
            logo_blue_PNG_100 = {logo_blue_PNG_100}
            logo_blue_PNG_70 = {logo_blue_PNG_70}
            logo_blue_PNG_16 = {logo_blue_PNG_16}
            mouse_graphic_icon = {mouse_graphic_icon}
          />



{/* SECTION 2: NAVIGATION ******************************/}

          <Navigation
            logo_blue_PNG_70 = {logo_blue_PNG_70}
            mouse_graphic_icon = {mouse_graphic_icon}

            logoLinkClicked = {this.logoLinkClicked}
            appsLinkClicked = {this.appsLinkClicked}
            motionGraphicsLinkClicked = {this.motionGraphicsLinkClicked}
            digitalArtLinkClicked = {this.digitalArtLinkClicked}
            musicLinkClicked = {this.musicLinkClicked}
          />



{/* NOTE: canvas container for isolating certain components */}

          <div className="canvas_container">

            <div className="canvas_overlay_inner" ref="AboutMe">



      {/* SECTION 3: ABOUT ME ******************************/}
              <ScrollableAnchor id={"_AboutMe"}>
                <div></div>
              </ScrollableAnchor>

              <div id="callbackSpacer_aboutMe" ref="AboutMe"></div>

              <AboutMe
                myEmail = {myEmail}
                myPhone = {myPhone}
                logo_white_PNG = {logo_white_PNG}
                logo_blue_PNG_960 = {logo_blue_PNG_960}
                logo_blue_PNG_100 = {logo_blue_PNG_100}
                logo_blue_PNG_70 = {logo_blue_PNG_70}
                logo_blue_PNG_16 = {logo_blue_PNG_16}

                copiedMessageClass_2 = {this.state.copiedMessageClass_2}
                copiedMessageClass_3 = {this.state.copiedMessageClass_3}
                contactMeToggle_2 = {this.state.contactMeToggle_2}

                onCopy = {() => this.onCopy()}
                contactButtonClicked_aboutMe = {(e) => this.contactButtonClicked_aboutMe()}
                contactButtonHover_ON_skills = {(e) => this.contactButtonHover_ON_skills()}
                contactButtonHover_OFF_skills = {(e) => this.contactButtonHover_OFF_skills()}
                contactButtonClicked_skills = {(e) => this.contactButtonClicked_skills()}
              />




            </div> {/* canvas_overlay_inner */}



      {/* SECTION 4: WORK ******************************/}



            {/* APPS */}

{
            // <div id="callbackSpacer_apps" ref="Apps"></div>

}

            <ScrollableAnchor id={"_Apps"}>
              <div></div>
            </ScrollableAnchor>

            <div id="callbackSpacer_apps" ref="Apps"></div>



            <Apps
              id="Apps_component"
              toggleVideo_1 = {(event) => this.toggleVideo_1()}
              toggleVideo_2 = {(event) => this.toggleVideo_2()}
              toggleVideo_3 = {(event) => this.toggleVideo_3()}
            />


            {/* MOTION GRAPHICS */}



            <div id="callbackSpacer_motionGraphics" ref="MotionGraphics"></div>

            <ScrollableAnchor id={"_MotionGraphics"}>
              <div></div>
            </ScrollableAnchor>

            <MotionGraphics id="MotionGraphics_component" />



            {/* DIGITAL ART */}

            <ScrollableAnchor id={"_DigitalArt"}>
              <div></div>
            </ScrollableAnchor>

            <div id="callbackSpacer_digitalArt" ref="DigitalArt"></div>


            <DigitalArt id="DigitalArt_component" />



            {/* MUSIC */}

            <ScrollableAnchor id={"_Music"}>
              <div></div>
            </ScrollableAnchor>

            <div id="callbackSpacer_music" ref="Music"></div>


            <Music id="Music_component" />



            {/* THIS WEBSITE */}

            <div id="callbackSpacer_resetMenuLinks"></div>

            <ThisWebsite
              myEmail = {myEmail}
              myPhone = {myPhone}
              logo_white_PNG = {logo_white_PNG}
              logo_blue_PNG_960 = {logo_blue_PNG_960}
              logo_blue_PNG_100 = {logo_blue_PNG_100}
              logo_blue_PNG_70 = {logo_blue_PNG_70}
              logo_blue_PNG_16 = {logo_blue_PNG_16}

              copiedMessageClass_1 = {this.state.copiedMessageClass_1}
              contactMeToggle = {this.state.contactMeToggle}

              onCopy = {() => this.onCopy()}
              contactButtonHover_ON_thisWebsite = {(e) => this.contactButtonHover_ON_thisWebsite()}
              contactButtonHover_OFF_thisWebsite = {(e) => this.contactButtonHover_OFF_thisWebsite()}
              contactButtonClicked_thisWebsite = {(e) => this.contactButtonClicked_thisWebsite()}
            />



            {
            // NOTE: NOT CURRENTLY IN USE -- keeping for reference and/or future use
            // <Skills
            //   myEmail = {myEmail}
            //   myPhone = {myPhone}
            //   logo_white_PNG = {logo_white_PNG}
            //   logo_blue_PNG_960 = {logo_blue_PNG_960}
            //   logo_blue_PNG_100 = {logo_blue_PNG_100}
            //   logo_blue_PNG_70 = {logo_blue_PNG_70}
            //   logo_blue_PNG_16 = {logo_blue_PNG_16}
            //
            //   copiedMessageClass_2 = {this.state.copiedMessageClass_2}
            //   copiedMessageClass_3 = {this.state.copiedMessageClass_3}
            //   contactMeToggle_2 = {this.state.contactMeToggle_2}
            //
            //   onCopy = {() => this.onCopy()}
            //   contactButtonClicked_aboutMe = {(e) => this.contactButtonClicked_aboutMe()}
            //   contactButtonHover_ON_skills = {(e) => this.contactButtonHover_ON_skills()}
            //   contactButtonHover_OFF_skills = {(e) => this.contactButtonHover_OFF_skills()}
            //   contactButtonClicked_skills = {(e) => this.contactButtonClicked_skills()}
            // />
            //
          }



          </div> {/* canvas_container */}



{/* SECTION 5: MORE ABOUT ME ******************************/}

          <MoreAboutMe
            myEmail = {myEmail}
            myPhone = {myPhone}
            logo_white_PNG = {logo_white_PNG}
            logo_blue_PNG_960 = {logo_blue_PNG_960}
            logo_blue_PNG_100 = {logo_blue_PNG_100}
            logo_blue_PNG_70 = {logo_blue_PNG_70}
            logo_blue_PNG_16 = {logo_blue_PNG_16}

            copiedMessageClass_1 = {this.state.copiedMessageClass_1}
            contactMeToggle = {this.state.contactMeToggle}

            onCopy = {() => this.onCopy()}
            contactButtonHover_ON_thisWebsite = {(e) => this.contactButtonHover_ON_thisWebsite()}
            contactButtonHover_OFF_thisWebsite = {(e) => this.contactButtonHover_OFF_thisWebsite()}
            contactButtonClicked_thisWebsite = {(e) => this.contactButtonClicked_thisWebsite()}

          />



{/* SECTION 6: FOOTER ******************************/}

          <Footer
            myEmail = {myEmail}
            myPhone = {myPhone}
            logo_white_PNG = {logo_white_PNG}
            logo_blue_PNG_960 = {logo_blue_PNG_960}
            logo_blue_PNG_100 = {logo_blue_PNG_100}
            logo_blue_PNG_70 = {logo_blue_PNG_70}
            logo_blue_PNG_16 = {logo_blue_PNG_16}
            backToTop_icon = {backToTop_icon}
          />



{/* ************************************************/}

      <ScrollableAnchor id={'_bottom'}>
        <div></div>
      </ScrollableAnchor>

      </div> {/*secondary enclosure*/}

    </div> // closes enclosure

    )




  } // render()

}

export default Home



// WEBPACK FOOTER //
// ./src/components/HomePage.js